import 'slick-carousel';

(function(Drupal, $, once) {
  'use strict';

  Drupal.behaviors.slideshow = {
    attach: function(context, settings) {

      $(once('slideshow', '.field--name-field-slideshow-images', context)).each(function() {
        let $thisSlideshow = jQuery(this);

        $thisSlideshow.slick({
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 2000,
          prevArrow: '<button class="slick-prev" aria-label="Previous slide">&lt;</button>',
          nextArrow: '<button class="slick-next" aria-label="Next slide">&gt;</button>',
          fade: true,
          dots: true,
          infinite: true
        });
      });
    }
  };

})(Drupal, jQuery, once);
